export default __webpack_public_path__ + "static/media/person.60d61d4d.svg";